import { type IconTypes } from '@procurify/ui'

export type CatalogItemTagIcon = IconTypes | 'warning'

export const CatalogItemTagIcons = {
  CATALOG: 'catalog',
  PREVIOUS_ORDER: 'action-history',
  WARNING: 'warning',
  CHECKMARK: 'checkmark',
} as const satisfies Record<string, CatalogItemTagIcon>
